/* eslint-disable */

import { useEffect } from "react";
import { useSelector } from "react-redux";

const CrispChat = () => {
  const account = useSelector((state) => state.AccountReducer);
  const store = useSelector((state) => state.StoreReducer);

  useEffect(() => {
    if (typeof window !== "undefined" && window.$crisp && account && store) {
      const safeString = (value, fallback = "غير متوفر") =>
        value !== undefined && value !== null ? String(value) : fallback;

      window.$crisp.push([
        "set",
        "user:nickname",
        safeString(account?.name, "غير معروف"),
      ]);
      window.$crisp.push([
        "set",
        "user:avatar",
        [store?.img ? store?.img : "https://foorweb.net/Logo.png"],
      ]);
      window.$crisp.push([
        "set",
        "user:email",
        safeString(account?.email || "no-email@foorweb.store"),
      ]);

      window.$crisp.push([
        "set",
        "user:phone",
        safeString(account?.phone || "+213000000000"),
      ]);

      // بيانات الجلسة - تحويل القيم إلى نصوص لتجنب الأخطاء
      window.$crisp.push([
        "set",
        "session:data",
        [
          [
            ["birthDay", safeString(account?.birthDay)],
            ["storeName", safeString(account?.storeName)],
            [
              "subscription_endDate",
              safeString(account?.subscription?.endDate),
            ],
            ["subscription_plan", safeString(account?.subscription?.plan)],
            ["tokens", safeString(account?.subscription?.tokens, "0")],
          ],
        ],
      ]);

      window.$crisp.push([
        "set",
        "user:company",
        [
          safeString(account?.name),
          { url: safeString(account?.store, "https://crisp.chat/") },
        ],
      ]);
    }
  }, [account]);

  return null;
};

export default CrispChat;
